// @flow
import * as React from 'react';
import { AccessTime } from '@material-ui/icons';

import Time from 'statsradio/domain/time/Time';
import TextInput from './TextInput';

interface Props {
  time: Time;
  name?: string;

  seconds?: boolean;
  onChange: (time: Time) => void;
}

interface State {
  value: string;
  mask: string;
}

function tryParseTime(value: string): Time | void {
  try {
    return Time.parse(value);
  } catch (e) {
    return undefined;
  }
}

function generateInputMask(seconds: boolean = false) {
  return seconds ? '99:99:99' : '99:99';
}

export class TimePickerInput extends React.PureComponent<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      value: props.time.toISO(),
      mask: generateInputMask(props.seconds),
    };
  }

  componentDidUpdate(prevProps: Props) {
    const currentTime = this.props.time;
    const prevTime = prevProps.time;

    if (!currentTime.is(prevTime)) {
      this.reset();
    }
  }

  onChange = (value: string) => this.setState({ value });

  onBlur = () => {
    const time = tryParseTime(this.state.value);

    if (time) {
      this.props.onChange(time);
    }
  };

  reset = () => this.setState({ value: this.props.time.toISO() });

  render() {
    const { name, seconds } = this.props;
    const { value, mask } = this.state;

    const width = seconds ? 100 : 66;

    return (
      <TextInput
        mask={mask}

        name={name}
        value={value}

        onChange={this.onChange}
        onBlur={this.onBlur}

        leftElement={<AccessTime fontSize="inherit" style={{ fontSize: 20 }} />}

        style={{ textAlign: 'center', width }}
      />
    );
  }
}

export default TimePickerInput;



// WEBPACK FOOTER //
// ./src/statsradio/components/ui/forms/TimePickerInput.js